import { Link, Typography } from "@mui/material";
import { Links } from "src/constants";
import { FeedItemDto } from "src/http";

interface IProps {
  feedItem: FeedItemDto;
}

const TagsPropertyChange = (props: IProps) => {
  const tags = props.feedItem.propertyChange!.value as string[];

  if (tags.length === 0) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> removed all tags</span>
      </Typography>
    );
  }

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated tags to </span>
      <strong>{tags.join(", ")}</strong>
    </Typography>
  );
};

export { TagsPropertyChange };
